import offlinePng from '@/assets/illustrations/empty/offline.png';
import { useOnline } from '@/hooks/use-online';

export function OfflineBanner() {
  const isOnline = useOnline();

  if (isOnline) return null;

  return (
    <div
      className="flex flex-row items-center gap-3 px-4 py-3 bg-[var(--color-surface)] border-b border-[var(--color-border)]"
      role="status"
      aria-live="polite"
      data-testid="offline-banner"
    >
      <img src={offlinePng} alt="" className="w-10 h-10 shrink-0 opacity-80 rounded" />
      <div className="flex flex-col gap-0.5">
        <p className="text-body-sm font-medium text-[var(--color-text-primary)]" data-testid="offline-banner-heading">
          System is Offline
        </p>
        <p className="text-body-xs text-[var(--color-text-placeholder)]" data-testid="offline-banner-subtext">
          You are currently off-grid. Changes will sync when you return to service.
        </p>
      </div>
    </div>
  );
}
